import {
    GET_HEADER,
    GET_HEADER_SUCCESS,
    GET_HEADER_FAIL,
} from "./action"
const initialState = {
    findServices: [],
    lastestBlog: null,
    wellnessLifeStyle: [],
    wellnessTravel: []
}
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_HEADER:
            return { ...state }
        case GET_HEADER_SUCCESS:
            return {
                ...action.payload
            }
        case GET_HEADER_FAIL:
            return { ...state }
        default: return { ...state }
    }
}


// WEBPACK FOOTER //
// ./src/components/header/reducer.js